export default "__VITE_ASSET__BlTYYdDR__"